import { CustomErrorClass, ErrorSeverity } from '../errors';
import { MessageParsers } from './utils/message-parsers';
import { determineMessageType } from './utils/determine-message-type';
export const messageParser = (messageResponse, sender) => {
    const messageType = determineMessageType(messageResponse);
    const typedMessageResponse = messageResponse;
    const parser = MessageParsers[messageType];
    if (parser) {
        return parser(typedMessageResponse, sender);
    }
    else {
        throw new CustomErrorClass(ErrorSeverity.Error, "Can't load new message", `Unsupported message type: ${String(messageType)}`);
    }
};
//# sourceMappingURL=messageParser.js.map